import React, { useEffect, useRef } from "react";
import TradeWorkflowPanel from "./TradeWorkflowPanel";
import "./TradeWorkflowModal.css";

export default function TradeWorkflowModal({
  open,
  onClose,
  tradeId,
  mode = "full_workflow",
}) {
  const closeBtnRef = useRef(null);
  const shellRef = useRef(null);

  useEffect(() => {
    if (!open) return;

    const onKey = (e) => {
      if (e.key === "Escape") {
        onClose?.();
      }
    };

    window.addEventListener("keydown", onKey);

    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    const t = setTimeout(() => {
      try {
        closeBtnRef.current?.focus?.();
      } catch {}
    }, 0);

    return () => {
      clearTimeout(t);
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = prevOverflow;
    };
  }, [open, onClose]);

  if (!open) return null;

  const stop = (e) => e.stopPropagation();

  return (
    <div className="twfm-backdrop" onClick={onClose} role="presentation">
      <div
        ref={shellRef}
        className="twfm-shell"
        onClick={stop}
        role="dialog"
        aria-modal="true"
        aria-label="Trade Safety Workflow"
      >
        <div className="twfm-head">
          <div className="twfm-title">Trade Safety Workflow</div>

          <button
            ref={closeBtnRef}
            className="twfm-close"
            type="button"
            onClick={onClose}
            aria-label="Close"
            title="Close"
          >
            ✕
          </button>
        </div>

        <div className="twfm-body">
          <TradeWorkflowPanel
            tradeId={tradeId}
            onClose={onClose}
            mode={mode}
          />
        </div>
      </div>
    </div>
  );
}
